import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from '@react-hook/window-size';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import useSound from 'use-sound';

import launchSound from '../assets/sounds/launch.mp3';
import celebrationSound from '../assets/sounds/celebration.mp3';
import cymbalSound from '../assets/sounds/cymbal.mp3';
import logoPilari from '../assets/images/pilari_dark.png';
import logoGZW from '../assets/images/gzw.png';

const CountdownCelebrationPageDirect = () => {
  const [seconds, setSeconds] = useState(0);
  const [isCounting, setIsCounting] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [width, height] = useWindowSize();

  const [playLaunch] = useSound(launchSound);
  const [playCelebration, { stop: stopCelebration }] = useSound(celebrationSound, { loop: true });
  const [playCymbal] = useSound(cymbalSound);

  useEffect(() => {
    let timer;
    if (isCounting && seconds > 0) {
      // ▶️ Mainkan cymbal saat detik ke-8 (artinya seconds === 2 karena countdown dari 10)
      if (seconds === 2) {
        playCymbal();
      }

      timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
    } else if (isCounting && seconds === 0) {
      setShowConfetti(true);
      setIsCounting(false);
      playCelebration();
    }

    return () => clearTimeout(timer);
  }, [seconds, isCounting, playCelebration, playCymbal]);

  const handleStart = () => {
    setSeconds(10);
    setIsCounting(true);
    setShowConfetti(false);
    playLaunch();
  };

  const handleRedirect = () => {
    stopCelebration();
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-white to-violet-100 px-4 relative overflow-hidden">
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          numberOfPieces={300}
          colors={['#7a75b5', '#a69bd6', '#ddd8f3']}
        />
      )}

      {/* Logo PILARI atas */}
      <img
        src={logoPilari}
        alt="Logo PILARI"
        className="w-36 sm:w-44 mt-20 mb-12"
      />

      <div className="w-full max-w-xl text-center flex flex-col items-center">
        {/* Judul sebelum countdown */}
        {!showConfetti && (
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[#7a75b5] leading-tight mb-10">
            Peluncuran Resmi <br />
            <span className="text-[#5f5aa6]">Aplikasi PILARI</span>
          </h1>
        )}

        {/* Tombol mulai */}
        {!isCounting && !showConfetti && (
          <button
            onClick={handleStart}
            className="px-8 py-3 rounded-full bg-[#7a75b5] text-white text-lg font-semibold shadow-md hover:bg-[#6a64a1] transition"
          >
            🚀 Mulai Countdown
          </button>
        )}

        {/* Progress Countdown */}
        {isCounting && (
          <div className="w-44 h-44 mt-4">
            <CircularProgressbarWithChildren
              value={(10 - seconds) * 10}
              maxValue={100}
              styles={buildStyles({
                pathColor: '#7a75b5',
                trailColor: '#eaeaea',
              })}
            >
              <div className="text-5xl font-extrabold text-[#5f5aa6]">{seconds}</div>
            </CircularProgressbarWithChildren>
          </div>
        )}

        {/* Setelah countdown selesai */}
        {showConfetti && (
          <div className="mt-12 w-full flex flex-col items-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#7a75b5] animate-bounce mb-3">
              🎉 PILARI Telah Resmi Diluncurkan!
            </h2>

            <p className="text-[#5f5aa6] text-lg sm:text-xl mb-6 leading-relaxed">
              Terima kasih telah menjadi bagian dari gerakan <br />
              <strong>Pilah Sampah Mandiri</strong>
            </p>

            <button
              onClick={handleRedirect}
              className="mt-2 px-6 py-2 bg-[#7a75b5] text-white rounded-full hover:bg-[#6a64a1] transition"
            >
              🚪 Lanjut ke Beranda
            </button>

            <p className="text-sm text-[#999] italic mt-8">
              "Satu tindakan kecil untuk lingkungan yang lebih besar"
            </p>
          </div>
        )}
      </div>

      {/* Footer: Logo GZW + teks, sejajar dan rapi */}
      <div className="mb-20 mt-12 flex items-center gap-3 sm:gap-4 justify-center">
        <p className="text-xs text-[#666]">Diselenggarakan oleh</p>
        <img
          src={logoGZW}
          alt="Garut Zero Waste"
          className="w-36 sm:w-44 opacity-90"
        />
      </div>
    </div>
  );
};

export default CountdownCelebrationPageDirect;